import { useNavigate } from "react-router-dom";

import styles from "./user-invalid-page.module.css";

const UserIsInValidPage = () => {
  const navigate = useNavigate();
  const hanndleHome = () => navigate("/auth");

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <img src="/images/avatar-hang.png" alt="" />
        <p className={styles.message}>
          {" "}
          برای افزودن حساب، باید اطلاعات و مدارک هویتی شما تایید شده باشد. برای پیگیری فرایند احراز هویت
          می‌توانید روی دکمه زیر کلیک نمایید:
        </p>
        <button onClick={hanndleHome} className={`main-btn ${styles.homeButton}`}>
          آخرین وضعیت
        </button>
      </div>
    </div>
  );
};

export default UserIsInValidPage;
